// extracted by mini-css-extract-plugin
export default {"faqSection":"FaqSection_faqSection__9MiMM","faqText":"FaqSection_faqText__NQWFo","accordion":"FaqSection_accordion__MfSep"};